<template>
  <form class="services-form main-modal" @submit.prevent="saveService" ref="service-form">
    <div class="r">
      <div class="main-modal__title">
        <p>{{ serviceData.title || $t("services.title") }}</p>
      </div>

      <div class="services-form__body">
        <div class="main-form__box">
          <span class="main-form__label">{{ $t("services.serviceName") }}:</span>
          <label>
            <input
              autocomplete="off"
              type="text"
              class="main-form__input"
              v-model="serviceData.title"
              placeholder=" "
              v-validate="{ required: true }"
              name="title"
            />
          </label>
        </div>

        <!-- <div class="main-form__box main-form__box_flex">
          <div class="main-form__half main-form__half_first">
            <span class="main-form__label"
              >{{ $t("services.serviceCost") }}:</span
            >
            <label>
              <input
                autocomplete="off"
                type="text"
                class="main-form__input"
                v-model="serviceData.price"
                placeholder=" "
                v-validate="{ required: true }"
                @keydown="priceFormat"
                name="price"
              />
            </label>
          </div>

          <div class="main-form__half main-form__half_second">
            <span class="main-form__label">{{ $t("forms.price15") }}:</span>
            <label>
              <input
                autocomplete="off"
                type="text"
                class="main-form__input"
                v-model="serviceData.price_fifteen"
                :placeholder="$t('forms.price15')"
                v-validate="{ required: true }"
                @keydown="priceFormat"
                name="price_fifteen"
              />
            </label>
          </div>
        </div>

        <div class="main-form__box main-form__box_flex">
          <div class="main-form__half main-form__half_first">
            <span class="main-form__label">Aufpreis 1:</span>
            <label>
              <input
                autocomplete="off"
                type="text"
                class="main-form__input"
                v-model="serviceData.percent_extra_price_1"
                :placeholder="'Aufpreis 1'"
                v-validate="{ required: true }"
                @keydown="priceFormat"
                name="price_fifteen"
              />
            </label>
          </div>

          <div class="main-form__half main-form__half_second">
            <span class="main-form__label">Aufpreis 2:</span>
            <label>
              <input
                autocomplete="off"
                type="text"
                class="main-form__input"
                v-model="serviceData.percent_extra_price_2"
                :placeholder="'Aufpreis 2'"
                v-validate="{ required: true }"
                @keydown="priceFormat"
                name="price_fifteen"
              />
            </label>
          </div>
        </div>-->

        <div class="main-form__box">
          <span class="main-form__label">Leistungen</span>

          <Select2
            v-model="serviceData.slug"
            :settings="{ placeholder: 'Wählen Sie bitte Leistung aus' }"
            v-validate="{ required: true }"
            name="slug"
            class="select2-container_w100"
            :options="[
              { id: 'electrician', text: $t('services.electrician') },
              { id: 'plumber', text: $t('services.plumber') },
              { id: 'handyman', text: $t('services.handyman') },
              { id: 'floor_tiles', text: 'Böden/Fliesen' },
            ]"
          />
        </div>

        <div class="main-form__box">
          <span class="main-form__label">{{ $t("services.description") }}:</span>
          <label>
            <textarea
              class="main-form__textarea"
              v-model="serviceData.description"
              placeholder=" "
              v-validate="{ required: true }"
              name="description"
            ></textarea>
          </label>
        </div>

        <div class="main-form__box">
          <div class="main-layout__item main-layout__item_head">
            <p class="w-6">#</p>
            <div class="w-20">Name</div>
            <div class="w-12">Preis 1</div>
            <div class="w-12">Preis (15m)</div>
            <div class="w-14">Aufpreis</div>
            <div class="w-16">Aufpreis 2</div>
            <div class="w-14">{{$t('listsHeader.actions')}}</div>
          </div>

          <div
            class="main-layout__item"
            v-for="(office, index) in serviceData.office_prices"
            :key="office.office_id"
          >
            <div class="w-6">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="w-20">{{ office.address }}</div>
            <div class="w-12">€{{ office.price }}</div>
            <div class="w-12">€{{ office.price_fifteen }}</div>
            <div class="w-14">{{ office.percent_extra_price_1 }}%</div>
            <div class="w-16">{{ office.percent_extra_price_2 }}%</div>
            <div class="w-14">
              <div class="flex">
                <svg
                  style="width:15px;height:15px;margin-right:10px"
                  @click="editOfficeModal(office)"
                >
                  <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
                </svg>
                <svg style="width:15px;height:15px" @click="removeOffice(office.office_id)">
                  <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
                </svg>
              </div>
            </div>
          </div>

          <button
            class="main-button main-button_green main-button_h30 main-button_w170 main-button_foz12 mt16"
            type="reset"
            @click="openOfficeModal"
          >Niederlassung hinzufügen</button>
        </div>

        <div class="service_isActive">
          <div class="services-list__isActive">
            <div class="custom-checkbox">
              <input
                type="checkbox"
                :id="`toActive${serviceData.id}`"
                v-model="serviceData.is_active"
              />
              <label :for="`toActive${serviceData.id}`"></label>
            </div>
          </div>

          <p>{{ $t("forms.active") }}</p>
        </div>

        <div class="services-form__actions services-form__actions_mb10">
          <label>
            <div class="services-form__action">
              <label
                class="icon"
                :style="[
                  serviceIcon || serviceData.icon
                    ? {
                        backgroundImage:
                          'url(' + (serviceIcon || serviceData.icon) + ')',
                      }
                    : '',
                ]"
              >
                <input
                  type="file"
                  v-validate="{ required: !isEdit }"
                  name="icon"
                  @change="updateIcon"
                />
              </label>
              <div class="content">
                <div class="content__title">{{ $t("services.downIcon") }}</div>
                <div class="content__desc">{{ $t("services.downIconTitle") }}</div>
              </div>
            </div>
          </label>

          <label>
            <div class="services-form__action">
              <label
                class="icon"
                :style="[
                  serviceSmallIcon || serviceData.small_icon
                    ? {
                        backgroundImage:
                          'url(' +
                          (serviceSmallIcon || serviceData.small_icon) +
                          ')',
                      }
                    : '',
                ]"
              >
                <input
                  type="file"
                  v-validate="{ required: !isEdit }"
                  name="small_icon"
                  @change="updateSmallIcon"
                />
              </label>
              <div class="content">
                <div class="content__title">{{ $t("services.downIcon") }} 2</div>
                <div class="content__desc">{{ $t("services.downIconTitle") }}</div>
              </div>
            </div>
          </label>
        </div>

        <div class="services-form__actions">
          <div class="services-form__action services-form__action_w50">
            <label
              class="icon icon--color"
              :style="{ background: serviceData.color }"
              @click="openPicker"
            ></label>
            <div class="closeOpenPicker" v-if="colorIsOpen" @click="colorIsOpen = false">
              <svg>
                <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
              </svg>
            </div>
            <sketch-picker
              :value="serviceData.color"
              @input="updateColor"
              v-validate="{ required: true }"
              name="color"
              class="colorpicker"
              v-if="colorIsOpen"
              @click.stop
            />
            <div class="content">
              <div class="content__title">{{ $t("services.serviceColor") }}</div>
              <div class="content__desc">{{ $t("services.serviceColorTitle") }}</div>
            </div>
          </div>

          <div class="services-form__action services-form__action_w50">
            <label for="animation" class="animation">
              <input type="file" id="animation" style="display:none" @change="uploadAnimation" />
            </label>

            <div class="content content_animation">
              <div class="content__title">{{ $t("services.serviceAnimation") }}</div>
              <div class="content__desc">{{ $t("services.serviceAnimationText") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FORM ACTIONS START -->
    <div class="main-form__buttons main-form__buttons_center">
      <span
        class="main-button main-button_cancel"
        @click="toggleServiceModal"
      >{{ $t("global.cancel") }}</span>
      <button
        class="save main-button main-button_success"
        :class="{
          disabled: !isValid || disableButton,
        }"
        :disabled="!isValid || disableButton"
        type="submit"
      >{{ $t("global.save") }}</button>
    </div>
    <!-- FORM ACTIONS END -->

    <modal :show="isShowOfficeModal" :dark="true" :outside="false" @close="closeOfficeModal">
      <office-price-modal
        v-if="isShowOfficeModal"
        @close="closeOfficeModal"
        @done="addOfficePrice"
        :office="office"
        :isUpdating="isUpdatingOffice"
      />
    </modal>
  </form>
</template>

<script>
import store from '@/store'
import { mapGetters, mapMutations } from 'vuex'
import officePriceModal from '@/components/modals/offices/officePriceModal'

export default {
    name: 'services-add-modal',
    components: {
        officePriceModal,
    },
    data() {
        return {
            colorIsOpen: false,
            serviceIcon: '',
            serviceSmallIcon: '',
            colors: [],
            showAnimation: false,
            disableButton: false,
            isShowOfficeModal: false,
            office: {
                office_id: '',
                address: '',
                price: 100,
                price_fifteen: 0,
                percent_extra_price_1: 0,
                percent_extra_price_2: 0,
            },
            isUpdatingOffice: false,
            prevOfficeId: null,
        }
    },
    computed: {
        ...mapGetters({
            serviceData: 'serviceSelfData',
            isEdit: 'isEditGetters',
            showService: 'serviceModalGetters',
            formDataServiceImgGetters: 'formDataServiceImgGetters',
            formDataServiceIconGetters: 'formDataServiceIconGetters',
            formDataServiceSmallIconGetters: 'formDataServiceSmallIconGetters',
        }),
        isValid() {
            if (this.serviceData.title === '' || this.serviceData.title === null) {
                return false
            }

            if (
                this.serviceData.description === ''
        || this.serviceData.description === null
            ) {
                return false
            }

            if (this.serviceData.office_prices.length === 0) {
                return false
            }

            if (this.serviceData.color === '' || this.serviceData.color === null) {
                return false
            }

            if (this.serviceData.slug === null || this.serviceData.slug === '') {
                return false
            }

            if (
                (this.formDataServiceIconGetters === ''
          || this.formDataServiceIconGetters === null)
        && !this.isEdit
            ) {
                return false
            }

            if (
                (this.formDataServiceSmallIconGetters === ''
          || this.formDataServiceSmallIconGetters === null)
        && !this.isEdit
            ) {
                return false
            }

            return true
        },
    },
    watch: {
        showService(v) {
            if (v) {
                return
            }

            this.$validator.reset()
            this.errors.items = this.errors.items.filter((e) => e.id !== '6')
        },
    },
    methods: {
        ...mapMutations({
            toggleServiceModal: 'setServiceModal',
            setServiceIcon: 'setServiceIcon',
            setServiceSmallIcon: 'setServiceSmallIcon',
        }),
        closeOfficeModal() {
            this.isShowOfficeModal = false
            this.isUpdatingOffice = false
        },
        openOfficeModal() {
            this.isShowOfficeModal = true
            this.office = {
                office_id: '',
                address: '',
                price: 100,
                price_fifteen: 0,
                percent_extra_price_1: 0,
                percent_extra_price_2: 0,
            }
        },
        editOfficeModal(item) {
            this.isUpdatingOffice = true

            this.office = {
                ...item,
                address: item.address,
                office_id: item.office_id,
            }

            this.prevOfficeId = item.office_id
            this.isShowOfficeModal = true
        },
        addOfficePrice(office) {
            if (!this.isUpdatingOffice) {
                this.serviceData.office_prices.push(office)
            } else {
                this.serviceData.office_prices = this.serviceData.office_prices.filter(
                    (item) => item.office_id !== this.prevOfficeId,
                )

                this.serviceData.office_prices.push(office)
            }

            this.closeOfficeModal()
        },
        removeOffice(id) {
            this.serviceData.office_prices = this.serviceData.office_prices.filter(
                (office) => office.office_id !== id,
            )
        },
        updateColor(value) {
            this.serviceData.color = value.hex
        },
        priceFormat(e) {
            if (
                (e.keyCode >= 48 && e.keyCode <= 57)
        || [190, 8, 9, 13].includes(e.keyCode)
            ) {
                return true
            } else {
                e.preventDefault()
                return false
            }
        },
        updateIcon(event) {
            const files = event.target.files[0]

            if (files) {
                const reader = new FileReader()
                reader.readAsDataURL(files)
                reader.onload = () => {
                    this.serviceIcon = reader.result
                }
            }

            const formData = new FormData()
            formData.append('icon', files)
            this.setServiceIcon(formData)
        },
        updateSmallIcon(event) {
            const files = event.target.files[0]

            if (files) {
                const reader = new FileReader()
                reader.readAsDataURL(files)
                reader.onload = () => {
                    this.serviceSmallIcon = reader.result
                }
            }

            const formData = new FormData()
            formData.append('small_icon', files)
            this.setServiceSmallIcon(formData)
        },
        openPicker() {
            this.colorIsOpen = !this.colorIsOpen
        },
        saveService() {
            this.disableButton = true

            if (!this.serviceData.color) {
                this.errors.items.push({
                    id: '6',
                    field: 'color',
                    msg: 'The icon field is required.',
                    rule: 'required',
                    scope: null,
                })
            }

            this.$validator.validate().then((valid) => {
                if (valid && this.serviceData.color) {
                    this.$Progress.start()
                    this.colorIsOpen = false

                    if (this.isEdit) {
                        store.dispatch('editService', this.serviceData.id).then(() => {
                            this.$Progress.finish()
                            this.serviceIcon = ''
                            this.$store.commit('emptyServiceData')
                            this.serviceSmallIcon = ''
                            this.disableButton = false
                        })
                    } else {
                        store.dispatch('addService').then(() => {
                            this.$Progress.finish()
                            this.serviceIcon = ''
                            this.$store.commit('emptyServiceData')
                            this.serviceSmallIcon = ''
                            this.disableButton = false
                        })
                    }
                }
            })
        },
        handleAnimation() {},
        async uploadAnimation({ target: { files } }) {
            const fd = new FormData()
            fd.append('animation', files[0])
            const status = await store.dispatch('updateServiceAnimation', {
                id: this.serviceData.id,
                data: fd,
            })

            if (status) {
                this.$notify({
                    title: this.$t('notifications.animationUploaded'),
                    message: this.$t('notifications.animationUploadedText'),
                    duration: 5000,
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.animation {
  width: 54px;
  height: 40px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 5px;
  margin-right: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.content_animation {
  width: 100%;
  padding-left: 7px;
}

.closeOpenPicker {
  border-radius: 100%;
  height: 30px;
  width: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: fixed;
  z-index: 9999;
  background-color: #fff;
  right: 30% !important;
  bottom: calc(10% + 280px);
  cursor: pointer;
}

.dark-theme {
  .service_isActive {
    input:checked + label:before {
      background-image: url(/images/icon/doneIconWhite.svg);
    }
  }
}
.light-theme {
  .service_isActive {
    input:checked + label:before {
      background-image: url(/images/icon/doneIcon.svg);
    }
  }
}
.service_isActive {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  p {
    margin-left: 10px;
    font-size: 14px;
  }

  input {
    display: none;
  }

  input:checked + label:before {
    position: absolute;
    content: "";
    left: 2px;
    right: 2px;
    top: 0;
    bottom: 2px;
    background-image: url(https://image.flaticon.com/icons/svg/60/60516.svg);
    background-position: center;
    z-index: 9;
    background-size: cover;
  }

  label {
    border: 2px solid var(--border-color);
    cursor: pointer;
    padding: 7px;
    display: block;
    position: relative;
  }
}

.services-form {
  width: 100%;
  height: auto;
  border-radius: 8px;
  // background-color: #ffffff;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  max-width: 470px;
  overflow: auto;
  color: var(--menu-text-color);

  &__head {
    background-color: $primaryColor;
    display: flex;
    justify-content: space-between;
    padding-left: 36px;
    //   padding-right: 24px;
    height: 50px;
    align-items: center;
    font-size: 22px;
    font-family: $fontBold;
    color: #ffffff;

    &-buttons {
      display: flex;
      align-items: center;

      & img:first-of-type {
        margin-right: 24px;
      }

      & .save {
        background-color: transparent;
        border: none;
        display: flex;
        cursor: pointer;

        &:focus {
          outline: none;
        }
      }
    }

    // &-text {

    // }
  }

  &__actions {
    display: flex;

    &_mb10 {
      margin-bottom: 10px;
    }
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    width: 60%;
    margin: 0 auto 30px;

    // button, span {
    //     padding: 10px 0px;
    //     border-radius: 8px;
    //     background-color: #61422d;
    //     -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    //     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    //     border: none;
    //     font-family: "SFUIDisplay-Bold";
    //     font-size: 15px;
    //     text-align: center;
    //     color: #ffffff;
    //     cursor: pointer;
    //     -webkit-transition: 0.5s;
    //     transition: 0.5s;
    //     outline: none;
    //     display: -webkit-box;
    //     display: -ms-flexbox;
    //     display: flex;
    //     -webkit-box-pack: center;
    //     -ms-flex-pack: center;
    //     justify-content: center;
    //     -webkit-box-align: center;
    //     -ms-flex-align: center;
    //     margin: 10px;
    //     width: 100px;

    //     &:hover {
    //         background-color: #fcee21;
    //         color: #000000 !important;
    //     }

    // }
  }

  &__img {
    position: relative;
    display: block;
    height: 150px;
    background-size: cover;
    background-position: center;
    background-image: url("/images/content/image-place-holder@2x.png");

    & .placeholder {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-image: url("/images/icon/add_avatar.svg");
      background-position: center;
      background-repeat: no-repeat;
      color: #ffffff;
      opacity: 0;
      transition: 0.5s;
    }

    &:hover .placeholder {
      opacity: 1;
    }

    & input {
      display: none;
    }
  }

  &__input {
    margin-bottom: 24px;

    &_last {
      margin-bottom: 7px;
    }

    & span {
      font-size: 14px;
      // color: #4d4d4d;
      font-family: $fontBold;
      display: block;
      margin-bottom: 5px;
    }

    & textarea.form-input {
      height: 60px;
    }
  }

  &__action {
    display: flex;
    align-items: stretch;
    margin-bottom: 13px;
    position: relative;
    width: 98%;

    &_w50 {
      width: 50%;
    }

    & .icon {
      width: 48px;
      height: 48px;
      background-size: cover;
      background-position: center;
      background-image: url("/images/icon/update-icon.svg");
      margin-right: 16px;
      flex-shrink: 0;
      display: block;
      border-radius: 10px;
      cursor: pointer;
      border: 1px solid var(--border-color);

      & input {
        display: none;
      }

      &--color {
        background-image: url("/images/icon/update-color.svg");
      }
    }

    & .content {
      &__title {
        font-size: 12px;
        // color: #4d4d4d;
        font-family: "crosten-bold";
        display: block;
        margin-bottom: 5px;
      }

      &__desc {
        font-size: 10px;
      }

      &_animation {
        display: flex;
        flex-direction: column;
        // justify-content: center;
      }
    }
  }
}

body .disabled:hover {
  background-color: #61422d !important;
  color: #fff !important;
}
</style>

<style>
.services-form .select2-selection--single {
  max-width: 360px !important;
}
</style>
